import './default-loading-icon.scss';
import classnames from 'classnames';

export interface LoadingIconProps {
  size?: 'small' | 'middle' | 'large' | 'huge';
}

const LoadingIcon: React.FC<LoadingIconProps> = ({ size = 'middle' }) => {
  return (
    <div className={classnames('csc-default-loading-icon', `csc-default-loading-icon-${size}`)} />
  );
};

export default LoadingIcon;
